import React from 'react';

/**
 * Progress bar and question counter for practice test
 */
const ProgressIndicator = ({
  currentQuestionIndex,
  totalQuestions,
  completedQuestions,
  themeStyles,
  isDarkMode
}) => {
  // Calculate progress percentage
  const progressPercentage = totalQuestions > 0 
    ? Math.round((completedQuestions / totalQuestions) * 100) 
    : 0;
  
  return (    <div className="question-progress" style={{
      width: '100%',
      marginBottom: '0', // Reduced from 10px to 0
      padding: '10px 20px', // Reduced from 20px 20px to 10px 20px
      backgroundColor: isDarkMode ? 'rgba(30, 41, 59, 0.5)' : 'rgba(248, 250, 252, 0.7)',
      borderRadius: '10px',
      border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(0, 0, 0, 0.03)',
      boxShadow: isDarkMode ? '0 2px 5px rgba(0, 0, 0, 0.1)' : '0 1px 4px rgba(0, 0, 0, 0.02)',
      transition: 'all 0.3s ease'
    }}>      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px' // Reduced from 10px to 6px
      }}>
        <span style={{ 
          color: isDarkMode ? '#f1f5f9' : '#334155', 
          fontWeight: 600, 
          fontSize: '15px'
        }}>
          Question {currentQuestionIndex + 1} of {totalQuestions}
        </span>
        <span style={{ 
          color: isDarkMode ? '#94a3b8' : '#64748b',
          backgroundColor: isDarkMode ? 'rgba(71, 85, 105, 0.3)' : 'rgba(241, 245, 249, 0.8)',
          padding: '4px 10px',
          borderRadius: '20px',
          fontSize: '13px',
          fontWeight: 500,
          border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.05)',
        }}>
          {progressPercentage}% Complete
        </span>
      </div>
      <div style={{
        width: '100%',
        height: '8px',
        background: isDarkMode ? 'rgba(71, 85, 105, 0.3)' : '#e2e8f0',
        borderRadius: '4px',
        overflowY: 'hidden',
        position: 'relative'
      }}>
        <div style={{
          width: `${progressPercentage}%`,
          height: '100%',
          backgroundColor: isDarkMode ? '#3b82f6' : '#2563eb',
          borderRadius: '4px',
          transition: 'width 0.3s ease',
          boxShadow: '0 0 5px rgba(59, 130, 246, 0.5)'
        }}></div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
